// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_bowser_src_bowser_js-node_modules_css-loader_dist_runtime_api_js-node_mo-0e46a1","vendors-node_modules_core-js_fn_array_includes_js-node_modules_core-js_fn_promise_finally_js--1b5d1a"], () => (__webpack_require__("./src/playground/index.jsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
